import api from './../api';
import request from "../utils/requestToJavaServer";
export function Admin_List({ category,username,pageNum, pageSize }: any) {
    return new Promise((resolve, reject) => {
        request.get(api.userManageApi.ADMIN_LIST, {
            params: {
                category,username,pageNum, pageSize
            }
        }).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Doctor_Authenticate(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_DOCTOR_AUTHENTICATE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Doctor_Unauthenticate(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_DOCTOR_UNAUTHENTICATE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Lock(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_LOCK, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Unlock(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_UNLOCK, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Enable(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_ENABLE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Disable(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_DISABLE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Logout(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_LOGOUT, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Restore(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_RESTORE, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Account_Expired(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_ACCOUNT_EXPIRED, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Account_Unexpired(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_ACCOUNT_UNEXPIRED, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Password_Expired(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_PASSWORD_EXPIRED, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Password_Unexpired(formData: FormData) {
    return new Promise((resolve, reject) => {
        request.post(api.userManageApi.ADMIN_PASSWORD_UNEXPIRED, formData).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}
export function Admin_Password_Reset(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.userManageApi.ADMIN_PASSWORD_RESET,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}
export function Admin_Integral(formData:FormData){
    return new Promise((resolve,reject)=>{
        request.post(api.userManageApi.ADMIN_INTEGRAL,formData).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        })
    })
}